<template>
	<div style="text-align: center;">
		<h2 style="margin-bottom: 30px;">请用微信扫码二维码注册账号</h2>

		<vue-qr ref="qrcode" :text="qrtext" :size="500" color="#333" bg-color="#fff"></vue-qr>

		<div class="cls_xieyi">
			<a style="margin-left: 35%;" target="_blank" href="/yinsi.html">隐私协议</a>

			<a style="margin-right: 35%;" target="_blank" href="/regArg.html">服务协议</a>
		</div>

	</div>
</template>

<script>
	import VueQr from 'vue-qr'

	export default {
		name: 'Register',
		components: {
			VueQr
		},

		data() {
			return {
				qrtext: "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxe767b997d8d79600&redirect_uri=http%3A%2F%2Fdzll.fanrencm.com&response_type=code&scope=snsapi_base&state=P!_!416916!_!00#wechat_redirect"
			}
		},
	}
</script>

<style scoped>
	a {
		color: red;
		border-bottom: 1px solid red;
	}


	.cls_xieyi {
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		margin-top: 20px;
	}
</style>